import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconEmail2"><Path d="M2 6.44916L11.322 11.1681C11.7479 11.3837 12.251 11.3837 12.6769 11.1681L21.999 6.44916C21.9719 5.09192 20.8632 4 19.4995 4H4.49949C3.13577 4 2.02707 5.09192 2 6.44916Z" fill="currentColor"/><Path d="M22 7.5697L13.1291 12.0603C12.4192 12.4196 11.5807 12.4196 10.8709 12.0603L2 7.5697V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V7.5697Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2;
